export interface HandlerParameters {
  condition: () => Promise<boolean | void> | boolean | void;
  trigger: () => any;
}

export const makeHandler = ({ condition, trigger }: HandlerParameters) => async(): Promise<any> => {
  const shouldTrigger = await condition();
  if (!shouldTrigger) return;
  return trigger();
};
